<template>
  <div class="maxwidth">
    <div class="search-positioner">
      <search-widget noline />
    </div>
    <div class="slideholder">
      <slide-show :slides="slides" :running="false" />
      
      <div class="slide-overlay" :class="{collapsed: collapsed}">
        <social-chunk name="instagram" />
        <social-chunk name="pinterest" />
        <div class="weare-illus">
          <div class="red-caps">#{{ $nippets.home.weareillx }}</div>
          <div class="message"><h1>{{ $nippets.home.message }}</h1></div>
        </div>
        <social-chunk name="facebook" />
        <social-chunk name="twitter" />
      </div>
      <plus-poker :collapsed="collapsed" v-on:click="handleUncollapse" />
    </div>
  </div>
</template>

<script>
import SlideShow from '@/components/widgets/HomeSlide.vue'
import apix from '@/api.js'
import SocialChunk from './SocialChunk.vue'
import SearchWidget from '@/components/widgets/SearchWidget.vue'
import PlusPoker from '@/components/buttons/PlusPoker.vue'

export default {
  components: {
    SlideShow,
    SocialChunk,
    SearchWidget,
    PlusPoker
  },
  data () {
    return {
      slides: [],
      collapsed: false,
      manual: false
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
    this.checkScroll()
    window.addEventListener('scroll', this.checkScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.checkScroll)
  },
  methods: {
    handleUncollapse() {
      this.collapsed = false
    },
    checkScroll() {
      if(!this.manual) {
        const bounding = this.$el.getBoundingClientRect();
        let pos = bounding.top + (bounding.height / 3)
        if(pos < 0) {
          this.collapsed = true
          this.manual = true
          // or stop listening here
        }
      }
      else {
        if(window.scrollY < 2) {
          this.manual = false
          this.collapsed = false
        }
      }
    },
    async loadData () {
      let res = await apix.get('home/current')
      let slides = []
      for(let item of res.data) {
        slides.push({ url: this.$k.imagebase + 'mediastore/home/' + item.filename, link: '/artists/' + item.artist } )
      }
      this.slides = this.$k.shuffleCopyArray(slides)
    }
  }
}
</script>

<style scoped>
.maxwidth{
 width:100%;
 max-width:1750px;
 position:relative;
}

.slideholder{
  position:relative;
  overflow:hidden;
}



.slide-overlay{
  position:absolute;
  background-color:rgba(255,255,255,0.9);
  min-height:120px;
  box-sizing:border-box;
  padding:20px;
  display:flex;
  justify-content:space-around;
  align-items:center;
  z-index:40;
  bottom:0;
  left:0;
  width:100%;
  transition:all 0.5s ease;
}

.slide-overlay.collapsed{
  transform:translateY(100%);
}

.weare-illus{
  width:35%;
  text-align:center;
}

.social-chunk{
  width:15%;
  text-align:center;
}

.red-caps{
  text-transform:uppercase;
  color:#ce0e2d;
  font-size:25px;
  font-weight:500;
}

.message{
  max-width:300px;
  margin-left:auto;
  margin-right:auto;
  margin-top:12px;
  text-align:center;
}

.message h1{
  font-weight:400;
  font-size:18px;
  margin:0;
  line-height:1.3em;
  display:inline;
}

.search-positioner{
  position:absolute;
  top:5%;
  left:45px;
  z-index:46;
}

@media screen and (max-width:1023px){
  .social-chunk{
    display:none;
  }
  .weare-illus{
    width:auto;
  }
  .slide-overlay{
    padding:8px 10px;
    min-height:30px;
  }
  .message{
    margin-top:0;
    font-size:14px;
    line-height:16px;
  }
  .search-positioner{
    left:12px;
  }
}
</style>